import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { Button } from '@forma/forma-ui-kit';
import PageBlock from '@/components/PageBlock';
// import Link from '@/components/Link';
import RequestDemoModal3 from '@/components/blocks/RequestDemoModal3';

import styles from './register-banner.module.css';

// const lkUrl = process.env.LK_URL;

const RegisterBanner = ({
  title = 'Оцените все возможности',
  description = 'Получите полный доступ к сервису на 7 дней. <br /> Перенесем и настроим до 5-ти шаблонов <br /> вашей компании бесплатно.',
  callModal
}) => {
  const { t } = useTranslation();
  // const { lang } = useContext(ThemeContext);
  const [isRequest3Open, setRequest3Open] = useState(false);

  return (
    <PageBlock variant="filled" className={styles.root} title={title}>
      <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
      <div className={styles.buttons}>
        <Button
          // as={Link}
          viewStyle="secondary"
          className={styles.button}
          onClick={() => setRequest3Open(true)}
        // href={`${lkUrl}/register?lng=${lang}`}
        >
          {callModal?.button ?? t('start_free')}
        </Button>
      </div>
      <RequestDemoModal3
        open={isRequest3Open}
        onClose={setRequest3Open}
        title={callModal?.title}
        description={callModal?.description}
      />
    </PageBlock>
  );
};

export default RegisterBanner;
